<header class="masthead" style="background-image: url('assets/img/home-program2.jpg');">
    <div class="overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-10 mx-auto" style="font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;">
                <div class="site-heading">
                    <h1 class="text-white">
                        Welcome
                    </h1>
                    <span class="text-white" class="subheading">The Blog Where I Share All Of My Story</span>
                </div>
            </div>
        </div>
    </div>
</header>
<div class="ps-main">
    <main class="ps-main">
        <div class="ps-blog-grid pt-80 pb-80">
          <div class="ps-container">
            <div class="row">
                  <div class="col-lg-9">
                    <app-list-of-post></app-list-of-post>
                  </div>
                  <div class="col-lg-3">
                    <app-vertical-side-bar></app-vertical-side-bar>
                  </div>
            </div>
          </div>
        </div>
      
      
      </main>
</div>


  